/**
 * Multiline note body control matching oasis `TextInput` field visuals.
 */

/** Props for the note body textarea. */
export interface NoteTextAreaFieldProps {
  id: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * Render the Add Note body field with the same label + input chrome as `TextInput`.
 *
 * @param props - Field id, label, placeholder, and controlled value
 * @returns Labeled note body field
 */
export function NoteTextAreaField({
  id,
  label,
  placeholder,
  value,
  onChange,
}: NoteTextAreaFieldProps) {
  return (
    <div className="flex w-full flex-col items-start gap-[0.38rem]">
      <label
        htmlFor={id}
        className="text-xs font-normal leading-[1.125rem] text-primaryGray-2"
      >
        {label}
      </label>
      <textarea
        id={id}
        name={id}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="box-border min-h-[7.5rem] w-full resize-y rounded border border-primaryGray-14 bg-white px-4 py-2 text-sm font-normal leading-[1.375rem] text-primaryGray-1 outline-none placeholder:text-xs placeholder:font-normal placeholder:leading-[1.125rem] placeholder:text-primaryGray-7 focus:border-primaryGray-2"
      />
    </div>
  );
}
